/** @jsx jsx */
import { jsx } from "theme-ui";

// Based on https://codepen.io/deriboru/pen/dOGRxw

const Laptop = ({children, className}) => {
  return (
    <div className={`object-laptop ${className}`} sx={{
      position: "relative",
      width: "100%"
    }}>
      <div className="screen" sx={{
        position: "relative",
        width: "80%",
        margin: "0 auto",
        border: "1px solid rgba(0,0,0,0.5)", // frame - bezel gap
        boxShadow: "0 0 0 3px rgba(64,64,64,1), " + // outer frame
          "inset 0 0 100px 0 rgba(0,0,0,0.75)", // bezel darken
        backgroundColor: "#1a1a1a", // bezel
        borderRadius: "7px 7px 0 0",

        // Sets the screen height
        "::before": {
          display: "block",
          position: "relative",
          content: "''", // extra quotes are needed
          //paddingTop: "62.5%" // 16:10
          paddingTop: "64.3%" // increased this a bit to fit an exactly 16:10 image
        }
      }}>
        <div className="lcd" sx={{
          position: "absolute",
          top: "1.9%",
          left: "1.1%",
          bottom: "3%",
          right: "1.1%",
          overflow: "hidden",
          border: "1px solid",
          borderColor: "#000 #1C1C1C #202020 #000",
          borderRadius: "3px",
          backgroundColor: "#000",
          boxShadow: "inset 0 0 200px 2px rgba(255,255,255,.05)"
        }}>
          {children}
        </div>
        <div className="gloss" sx={{
          position: "absolute",
          top: 0,
          left: 0,
          width: "100%",
          height: "100%",
          borderRadius: "7px 0 0 0",
          background: "linear-gradient(135deg, rgba(255,255,255,0.1) 0%,rgba(255,255,255,0) 50%)"
        }}/>
        <div className="reflection" sx={{
          position: "absolute",
          top: 0,
          left: 0,
          width: "100%",
          height: "100%",
          borderRadius: "7px 0 0 0",
          background: "linear-gradient(100deg, rgba(0,0,0,0) 0%, rgba(255,255,255,.05) 0.1%,rgba(255,255,255,.09) 33%, rgba(0,0,0,0) 33.1%)"
        }}/>
        <div className="highlight-top-frame" sx={{
          position: "absolute",
          borderRadius: "7px",
          top: "-4px",
          left: "2%",
          width: "80%",
          height: "2px",
          background: "linear-gradient(135deg, rgba(255,255,255,0) 0%, rgba(255,255,255,0.5) 15%, rgba(0,0,0,0) 100%)",
        }}/>
        <div className="highlight-left-frame" sx={{
          position: "absolute",
          borderRadius: "7px",
          top: "2%",
          left: "-4px",
          width: "2px",
          height: "80%",
          background: "linear-gradient(135deg, rgba(255,255,255,0) 0%, rgba(255,255,255,0.25) 15%, rgba(0,0,0,0) 100%)"
        }}/>
      </div>
      <div className="keyboard" sx={{
        position: "relative",
        width: "100%",
        paddingBottom: "0.45%", // height
        borderRadius: "1px 1px 0 0",
        background:
          // left shine
          "linear-gradient(90deg, rgba(255,255,255,0.4) 0%, rgba(0,0,0,.75) 2%, rgba(0,0,0,.33) 7%, rgba(0,0,0,0.1) 100%)," +
          // right shine
          "linear-gradient(90deg, rgba(0,0,0,0.1) 0%, rgba(0,0,0,.33) 93%, rgba(0,0,0,.75) 98%, rgba(255,255,255,0.4) 100%)," +
          // center shine
          "linear-gradient(90deg, rgba(255,255,255,0) 20%, rgba(255,255,255,.35) 33%, rgba(255,255,255,.35) 35%, rgba(0,0,0,0) 100%)," +
          // solid color
          "linear-gradient(0deg, rgba(20,20,20,1) 0%, rgba(20,20,20,1) 100%)",

        // grip
        "::after": {
          display: "inline-block",
          content: "''", // extra quotes are needed
          position: "absolute",
          top: 0,
          left: "50%",
          transform: "translate(-50%,0)",
          width: "10%",
          paddingBottom: "0.45%", // height
          background: "linear-gradient(90deg, rgba(0,0,0,1) 0%, rgba(0,0,0,0.5) 12%, rgba(0,0,0,0.5) 90%, rgba(0,0,0,1) 100%)",
          boxShadow: "inset 0 0 0 1px rgba(0,0,0,0.2)"
        }
      }}/>
      <div className="body" sx={{
        position: "relative",
        width: "100%",
        paddingBottom: "3.0%", // height
        borderRadius: "0 0 33% 33%",
        background:
          // left shine
          "linear-gradient(90deg, rgba(0,0,0,0.3) 0%, rgba(0,0,0,0.75) 2%, rgba(0,0,0,0.5) 7%, rgba(0,0,0,0.1) 50%)," +
          // right shine
          "linear-gradient(90deg, rgba(0,0,0,0.1) 0%, rgba(0,0,0,0.5) 83%, rgba(0,0,0,0.75) 98%, rgba(0,0,0,0.3) 100%)," +
          // bottom gradient
          "linear-gradient(0deg, rgba(0,0,0,0.75) 0%, rgba(0,0,0,0.25) 33%, rgba(255,255,255,1) 34%, rgba(255,255,255,1) 100%)," +
          // solid color #C8C8C8
          "linear-gradient(0deg, rgba(200,200,200,1) 0%, rgba(200,200,200,1) 100%)",

        // grip
        "::after": {
          display: "inline-block",
          content: "''", // extra quotes are needed
          position: "absolute",
          top: 0,
          left: "50%",
          transform: "translate(-50%,0)",
          width: "10%",
          paddingBottom: "0.8%", // height
          background: "linear-gradient(0deg, rgba(255,255,255,.75) 0%, rgba(0,0,0,.5) 100%)",
          boxShadow: "inset 0 -1px 3px 1px rgba(0,0,0,.2)",
          borderRadius: "0 0 5px 5px"
        }
      }}/>
    </div>
  );
};

export default Laptop;